var map = {
	"./DISTRIBUTION/components/main-lot-table.vue": "80cd",
	"./DISTRIBUTION/components/main-test.vue": "0b8d",
	"./LAB/components/main-lot-table.vue": "a4af",
	"./LAB/components/main-test.vue": "b5c9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b889";